<template>
  <div class="OrderEnroll">
    <div class="titlePage">Ordenes de Matricula</div>
    <va-notification color="danger" v-if="refNoReport" class="refNoData">El servicio que ejecuta el reporte no se encuentra activo.</va-notification>
    <div class="OrderList OrderListData" v-if="!this.$store.state.PeriodProccess.Sta_Active">
      <vue-list-picker
        :left-items="leftItems"
        :right-items="rightItems"
        height="300px"
        title-left="Periodos Activos"
        title-right="Periodos a Validar"
        :content-substr="40"
        title-class="titleList"
        button-class="buttonList"
        content-key="id"
        content-attr="value"
      />
      <div class="valPerid">
        <span v-if="viewValP">* Para generar el reporte se debe asignar minimo un periodo activo.</span>
      </div>
      <button type="submit" v-on:click="this.ListOrders" class="loginbtn primaryBtn">Generar Estados de Estudiantes</button>
    </div>
    <div class="OrderListData" v-if="this.$store.state.PeriodProccess.Sta_Active">
      <table class="table">
        <tbody>
          <tr>
            <th class="titleData" scope="row">ID Reporte</th>
            <td>{{this.$store.state.PeriodProccess.Id_ParametricHeader}}</td>
            <td class="titleData" >Estado de Ejecuación</td>
            <td>
              <div v-if="this.$store.state.PeriodProccess.Id_LoadView">
                  En proceso
              </div>
              <div v-else>
                  Inicializada
              </div>
            </td>
          </tr>
          <tr>
            <th class="titleData" scope="row">Detalle</th>
            <td>{{this.$store.state.PeriodProccess.Des_ParametricHeader}}</td>
            <td class="titleData">Referencia de la Ejecuación</td>
            <td>
                <div v-if="this.$store.state.PeriodProccess.Id_LoadView" >
                    {{this.$store.state.PeriodProccess.Sta_LoadView.LoadVIew[0].Guid_LoadView}}
                </div>
                <div class="valDetail" v-else>
                  Sin asignar
                </div>
            </td>
          </tr>
          <tr>
            <th class="titleData" scope="row">Fecha de Ejecución</th>
            <td>{{this.$store.state.PeriodProccess.Date_ParametricHeader}}</td>
            <td class="titleData">Detalle de la Ejecuación</td>
            <td>
              <div v-if="this.$store.state.PeriodProccess.Id_LoadView" >
                <router-link :to="'OrderEnrollStatus'"><button  class="loginbtn primaryBtnDetail ma-0" >Detalle</button></router-link>
              </div>
              <div class="valDetail" v-else>
                  Sin asignar
                </div>
            </td>
          </tr>
        </tbody>
      </table>
      <va-notification color="info" v-if="addRExito" class="refNoData">Se genero correctamente la tarea para listar los estados de los estudiantes, una vez finalizada esta tarea se le informar al correo  la activación.</va-notification>
    </div>
    <div class="Separador"></div>
    <ListHistory
      v-if="renderComponent1"
    />
  </div>
</template>

<script>
import ListHistory from '@/components/data-tables/DataHistory.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'OrderEnroll',
  data () {
    return {
      leftItems: [],
      rightItems: [],
      sendPeriod: [],
      renderComponent1: true,
      renderComponent2: true,
      viewValP: false,
      refNoReport: false,
      addRExito: false,
    }
  },
  components: {
    ListHistory,
  },
  methods: {
    PeriodsData () {
      var ListHistory = IberoHelpers.getPeriodLoad(this.$store)
      ListHistory.then(Response => {
        if (!(Response.data.OMPeriods === undefined)) {
          this.$store.state.PeriodProccess = Response.data.OMPeriods[0]
        } else {
          this.$store.state.PeriodProccess = ''
        }
      })
    },
    ListOrders () {
      if (this.rightItems.length >= 1) {
        this.viewValP = false
        for (var i = 0; i < this.rightItems.length; i++) {
          this.sendPeriod.push({ Id_Period: this.rightItems[i].id })
        }
        var UpdateOM = IberoHelpers.sendPeriodsOM(this.$store, this.sendPeriod)
        UpdateOM.then(Response => {
          if (Response.data.status === '200') {
            this.renderComponent1 = false
            IberoHelpers.forceRerender1(this)
            this.PeriodsData()
            IberoHelpers.executeLoadView(this.$store)
            this.addRExito = true
          } else {
            this.refNoReport = true
          }
        })
      } else {
        this.viewValP = true
      }
    },
  },
  created: function () {
    let loader = this.$loading.show()
    this.PeriodsData()
    var ListPeriods = IberoHelpers.getPeriodList(this.$store)
    ListPeriods.then(Response => {
      for (var i = 0; i < Response.data.length; i++) {
        this.leftItems.push(
          { id: Response.data[i].idPeriod, value: Response.data[i].desPeriod + ' : ' + IberoHelpers.dataObjDate(Response.data[i].datStartDate) + ' - ' + IberoHelpers.dataObjDate(Response.data[i].datEndDate) }
        )
      }
      loader.hide()
    })
  },
}
</script>

<style scoped>
.OrderList{
  text-align: center;
}
.noShow{
  display: none;
}
.refNoData{
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.OrderListData{
  padding: 20px;
}
.Separador{
  margin-top: 30px;
}
.valPerid{
  float: left;
  color: red;
  height: 10px;
  font-size: 12px;
}
.valDetail{
  color: red;
}
.titleData{
  font-weight: bold;
}
</style>
